import en from './en.js';
import zh from './zh.js';

export default function(){
  if(navigator.language.startsWith('zh')){
    return zh;
  } else {
    return en;
  }
}